"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var vdl_prefix_1 = require("../util/vdl-prefix");
var classnames_1 = require("../util/classnames");
function calcPoints(vertical, marks, dots, step, min, max) {
    if (step == null || step <= 0) {
        throw new Error('`Slider[step]` should be a positive number in order to make Slider[dots] work.');
    }
    var points = Object.keys(marks).map(parseFloat);
    if (dots) {
        for (var i = min; i <= max; i = i + step) {
            if (points.indexOf(i) >= 0) {
                continue;
            }
            points.push(i);
        }
    }
    return points;
}
exports.Steps = function (props) {
    var vertical = props.vertical, marks = props.marks, dots = props.dots, step = props.step, max = props.max, min = props.min, included = props.included, upperBound = props.upperBound, lowerBound = props.lowerBound;
    var range = max - min;
    var elements = calcPoints(vertical, marks, dots, step, min, max)
        .map(function (point) {
        var _a;
        var offset = Math.abs(point - min) / range * 100 + "%";
        var style = vertical ? { bottom: offset } : { left: offset };
        var isActive = (!included && point === upperBound) || (included && point <= upperBound && point >= lowerBound);
        var pointClassName = classnames_1.classNames((_a = {},
            _a[vdl_prefix_1.vdlPrefix('slider__dot')] = true,
            _a[vdl_prefix_1.vdlPrefix('slider__dot--active')] = isActive,
            _a[vdl_prefix_1.vdlPrefix('slider__dot--min')] = point === min,
            _a[vdl_prefix_1.vdlPrefix('slider__dot--max')] = point === max,
            _a));
        return React.createElement("div", { className: pointClassName, style: style, key: point });
    });
    return React.createElement("div", { className: vdl_prefix_1.vdlPrefix('slider__steps') }, elements);
};
exports.Steps.displayName = 'Steps';
